// services/postos.js
import axiosInstance from './axiosInstance';

const POSTOS_API_URL = '/postos';

const postosService = {
  async get(idempresa) {
    try {
      const response = await axiosInstance.get(`${POSTOS_API_URL}/get.php?idempresa=${idempresa}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async getById(idempresa, posto) {
    try {
      const response = await axiosInstance.get(`${POSTOS_API_URL}/getById.php?idempresa=${idempresa}&posto=${posto}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async set(postoData) {
    try {
      const response = await axiosInstance.post(`${POSTOS_API_URL}/set.php`, postoData);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async unset(idempresa, posto) {
    try {
      const response = await axiosInstance.get(`${POSTOS_API_URL}/unset.php?idempresa=${idempresa}&posto=${posto}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async getStockThresholds(idempresa, idposto) {
    try {
      const response = await axiosInstance.get(`${POSTOS_API_URL}/stocks/thresholds/get.php?idempresa=${idempresa}&idposto=${idposto}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter limiares de stock:', error);
      return [];
    }
  },

  async getStockById(idempresa, idproduct, idposto) {
    try {
      const response = await axiosInstance.get(`${POSTOS_API_URL}/stocks/getById.php?idempresa=${idempresa}&idproduct=${idproduct}&idposto=${idposto}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter stock:', error);
      return [];
    }
  },

  async getStocksById(idempresa, date, idposto, idproduct = null, familia = null) {
    try {
      let url = `${POSTOS_API_URL}/stocks/getById.php?idempresa=${idempresa}&date=${date}&idposto=${idposto}`;
      
      if (idproduct) {
        url += `&idproduct=${idproduct}`;
      }
      if (familia) {
        url += `&familia=${familia}`;
      }
      
      const response = await axiosInstance.get(url);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  // Método para compatibilidade com o ordersService que usa params object
  async getStocksByIdWithParams(idempresa, params) {
    try {
      const { date, idposto, familia } = params;
      const response = await axiosInstance.get(`${POSTOS_API_URL}/stocks/getById.php?idempresa=${idempresa}&date=${date}&idposto=${idposto}&familia=${familia}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter stocks:', error);
      return [];
    }
  }
};

export default postosService;
